import clsx from "clsx";
import React from "react";

import NotificationBlock from "~/components/notificationBlock/NotificationBlock.tsx";

import styles from "./AlertCard.module.scss";

type Props = {
  type?: "danger" | "success" | "warning" | "info" | "neutral";
  title?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  withIcon?: boolean;
  neutralHeader?: boolean;
};

export const AlertCard = ({
  type,
  title,
  content,
  actions,
  className,
  withIcon = false,
  neutralHeader = true,
}: Props) => {
  const hasTitle = Boolean(title);

  return (
    <NotificationBlock type={type} withIcon={withIcon} className={className}>
      <div
        className={clsx(styles.alertCardContainer, {
          [styles.noTitle]: !hasTitle,
        })}
      >
        {hasTitle && (
          <div
            className={clsx(styles.title, {
              [styles.inheritColor]: !neutralHeader,
            })}
          >
            {title}
          </div>
        )}
        {content && <div className={styles.content}>{content}</div>}
        {actions && <div className={styles.buttonsContainer}>{actions}</div>}
      </div>
    </NotificationBlock>
  );
};
